import serverData from '../server-data'

export const getTermsAndConditionsLink = () => {
  return serverData.urls.terms
}
